export default "__VITE_ASSET__C_b6hR1W__"